import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import DashboardLayout from '../../components/layout/DashboardLayout';
import ProductivitySummary from './components/ProductivitySummary';
import WellnessSummary from './components/WellnessSummary';
import GrowthSummary from './components/GrowthSummary';
import FinancesSummary from './components/FinancesSummary';
import { useAuth } from '../../context/AuthContext';
import './DashboardPage.css';

const DashboardPage = () => {
  const { user } = useAuth();

  return (
    <DashboardLayout>
      <div className="dashboard-container">
        <motion.div 
          className="page-header"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>Welcome back, {user?.displayName?.split(' ')[0]}</h1>
          <p>Here's an overview of your progress</p>
        </motion.div>

        <motion.div 
          className="dashboard-content"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
        >
          <div className="dashboard-grid">
            <ProductivitySummary />
            <WellnessSummary />
            <GrowthSummary />
            <FinancesSummary />
          </div>
        </motion.div>
      </div>
    </DashboardLayout>
  );
};

export default DashboardPage; 